import { DatePipe } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng-lts/dynamicdialog';
import {
  I18nData,
  TaskDTO,
  TenderV2DTO,
  getSimpleIdentifierFromString,
} from '../../api/plyca-dtos';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { FormConfig } from '../../components/forms/form.objects';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import {
  HelpService,
  HelpType,
} from '../../components/common/help/help.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { UserService } from '../../user.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { Observable, forkJoin, of, pipe } from 'rxjs';
import {
  ProcurementProjectLotDTO,
  RequestMaterialDTO,
  RequestedMaterialFilter,
  TenderRequestedMaterialDTO,
  TenderRequestedMaterialFilterDTO,
} from '../../api/plyca-dtos-v2';
import * as lodash from 'lodash';
import { TenderRequestedMaterialComponent } from './TenderRequestedMaterial.component';
import { ActionService } from '../../actions/action.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { ConfirmationService } from 'primeng-lts/api';

@Component({
  selector: 'tender-requestedMaterial',
  templateUrl: 'TenderRequestedMaterialList.template.html',
  providers: [DatePipe, DialogService],
})
export class TenderRequestedMaterialListComponent
  extends BaseComponent
  implements AfterContentInit, OnDestroy, OnInit
{
  loaded = false;
  elements: RequestMaterialDTO[] = [];

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  public tenderFilterModel: TenderRequestedMaterialFilterDTO;
  public feFilterModel: RequestedMaterialFilter;

  windowHash: string;
  tender: TenderV2DTO;
  showLotes = false;
  public task: TaskDTO;
  readOnly = false;

  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    public translateService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    protected route: ActivatedRoute,
    private actionService: ActionService,
    private confirmationService: ConfirmationService
  ) {
    super();

    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.TENDER_MATERIAL)
    );
    if (dialogConfig['context'] && dialogConfig['context']['tender']) {
      this.tender = dialogConfig['context']['tender'];
      this.showLotes = this.tender['project'].breakdownLot.apportioned === true;
      this.readOnly = dialogConfig['context']['readonly'];
    }
    this.task = dialogConfig?.data?.task;
    this.dtoToModel();
  }
  ngOnInit(): void {
    this.windowHash = generateRandomIdentifier();
  }

  dtoToModel() {
    if (this.tender) {
      this.tenderFilterModel = new TenderRequestedMaterialFilterDTO();
      this.tenderFilterModel.tender = this.tender;
    } else {
      this.feFilterModel = { lot: new ProcurementProjectLotDTO() };
      this.feFilterModel['lot'] = new ProcurementProjectLotDTO();
      this.feFilterModel.lot.lotId = 0;
    }

    this.subscribe(this.createFormConfig1(), (form1: FormConfig) => {
      this.formConfig1 = form1;
    });
  }

  private createFormConfig1(): Observable<FormConfig> {
    let filter;
    if (this.tender) {
      filter = this.tenderFilterModel;
    } else {
      filter = this.feFilterModel;
    }

    return of(
      new FormConfig(
        undefined,
        'requestedMaterial/TenderRequestedMaterialFilterISettings.json',
        filter
      )
    );
  }

  ngAfterContentInit(): void {
    this.subscribe(
      forkJoin([
        this.plycaService.getAvailableAction(
          'EXPORT_TENDER_REQUESTEDMATERIAL',
          this.tender.identifier,
          'TENDER'
        ),

        this.plycaService.getAvailableAction(
          'IMPORT_TENDER_REQUESTEDMATERIAL',
          this.tender.identifier,
          'TENDER'
        ),
      ]).pipe(
        map((prop: any[]) => {
          if (prop[0] && prop[0].actions) {
            prop[0].actions.forEach((action) => {
              this.subscribe(
                this.headerActionsService.addWindowAction(
                  action.name,
                  this.actionService.getActionIconClass(action),
                  'btn-secondary',
                  true,
                  this.windowHash,
                  !this.readOnly
                ),
                (success) => {
                  console.log(success);
                  let config: DynamicDialogConfig = {
                    header: action.name,

                    width: '70%',
                    styleClass: 'actionStyle',
                    style: { overflow: 'hidden' },
                  };
                  config['action'] = action;

                  this.dialogService.open(ActionsProcessComponent, config);
                }
              );
            });
          }
          if (prop[1] && prop[1].actions) {
            prop[1].actions.forEach((action) => {
              this.subscribe(
                this.headerActionsService.addWindowAction(
                  action.name,
                  this.actionService.getActionIconClass(action),
                  'btn-secondary',
                  true,
                  this.windowHash,
                  !this.readOnly
                ),
                (success) => {
                  console.log(success);
                  let config: DynamicDialogConfig = {
                    header: action.name,

                    width: '70%',
                    styleClass: 'actionStyle',
                    style: { overflow: 'hidden' },
                  };
                  config['action'] = action;

                  let curentHelpTags = [];
                  this.subscribe(
                    this.helpService
                      .getStoreTagsObservable()
                      .pipe(
                        switchMap((helpTags) => (curentHelpTags = helpTags))
                      )
                  );
                  const ref = this.dialogService.open(
                    ActionsProcessComponent,
                    config
                  );
                  this.subscribe(
                    ref.onClose,
                    (result) => {
                      /*if (response && response.actionId !== this.CANCEL_ACTION.actionId) {
                 this.emitUpdate(rowData, response.model);
                }*/
                      this.subscribe(
                        this.helpService.showContextHelpObservable(
                          curentHelpTags
                        )
                      );
                      this.loadData();
                    },
                    (error: any) => {
                      const ref1 =
                        this.plycaErrorHandler.showServerError(error);

                      this.subscribe(ref1.onClose, (result) => {
                        this.loadData();
                      });

                      console.log(error);
                    }
                  );
                }
              );
            });
          }
        }),
        finalize(() => {
          this.generalActions();
          // this.waitService.cancelWaiting(); // Al finalizar (ok o con error)  se cancela la capa de espera.
        })
      )
    );

    this.loadData();
  }
  generalActions() {
    // this.headerActionsService.setTaskDescription(this.elem,
    // ControlPanel.inboxs.title', 'fas fa-inbox', this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'General.add',
        'fas fa-plus',
        'btn-outline-primary',
        true,
        this.windowHash,
        !this.readOnly
      ),
      (success) => {
        this.openEditor(undefined);
      }
    );
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      (success) => {
        this.ref.close();
      }
    );
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public clearFilter(): void {
    this.tenderFilterModel = new TenderRequestedMaterialFilterDTO();
  }

  loadData() {
    this.waitService.startWaiting();
    this.loaded = false;

    let params = {};
    // Se consulta por expediente y oferta
    params['expand'] = 'lot';
    params['projectId'] = this.tender.division.project.identifier;
    params['orderNumber'] = this.tender.orderNumber;
    if (this.tenderFilterModel?.description) {
      params['description'] = this.tenderFilterModel.description;
    }
    if (this.tenderFilterModel?.supplierReference) {
      params['supplierReference'] = this.tenderFilterModel.supplierReference;
    }
    if (this.tenderFilterModel?.referenceCode) {
      params['referenceCode'] = this.tenderFilterModel.referenceCode;
    }

    if (JSON.stringify(params) === '{}') {
      this.uiService.showMessage(
        new I18nData('ControlPanel.inboxs.msg.filters'),
        new I18nData('General.info')
      );
      this.loaded = true;
      this.waitService.cancelWaiting();
    } else {
      this.subscribe(
        this.plycaService
          .query<any>(
            this.configuration.TENDER_REQUESTEDMATERIAL_SERVICE_URL,
            params
          )
          .pipe(
            finalize(() => {
              this.loaded = true;
              this.waitService.cancelWaiting();
            })
          ),
        (results) => {
          if (results && results.content) {
            this.elements = results.content;
          } else {
            this.elements = [];
          }
          this.loaded = true;
        },
        (error) => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error);
        }
      );
    }
  }

  openEditor(rowData?: TenderRequestedMaterialDTO) {
    let context = {};
    let title = 'Nuevo';
    if (rowData) {
      title =
        rowData && rowData.requestedMaterial.referenceCode
          ? rowData.requestedMaterial.referenceCode
          : '';
    }
    let config: DynamicDialogConfig = {
      header: title,
      width: '90%',
      styleClass: 'formEdition',
      closable: true,
      closeOnEscape: true,
    };

    let element;

    if (rowData !== undefined) {
      element = lodash.cloneDeep(rowData);
    }
    context['readonly'] = this.readOnly;
    context['tender'] = this.tender;
    context['element'] = element;
    config['context'] = context;
    config.data = {
      task: this.task,
    };

    let curentHelpTags = [];
    this.subscribe(
      this.helpService
        .getStoreTagsObservable()
        .pipe(switchMap((helpTags) => (curentHelpTags = helpTags)))
    );
    const ref = this.dialogService.open(
      TenderRequestedMaterialComponent,
      config
    );
    this.subscribe(
      ref.onClose,
      (result) => {
        /*if (response && response.actionId !== this.CANCEL_ACTION.actionId) {
   this.emitUpdate(rowData, response.model);
  }*/
        this.subscribe(
          this.helpService.showContextHelpObservable(curentHelpTags)
        );
        this.loadData();
      },
      (error: any) => {
        const ref1 = this.plycaErrorHandler.showServerError(error);

        this.subscribe(ref1.onClose, (result) => {
          this.loadData();
        });

        console.log(error);
      }
    );
  }

  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }

  removeRow(tendermaterial: any) {
    this.confirmationService.confirm({
      message: this.translateService.instant('Forms.table.deleteRow'),
      acceptLabel: this.translateService.instant('General.yes'),
      rejectLabel: this.translateService.instant('General.no'),
      accept: () => {
        this.subscribe(
          this.plycaService.delete<TenderRequestedMaterialDTO>(
            this.configuration.TENDER_REQUESTEDMATERIAL_SERVICE_URL,
            tendermaterial.identifier
          ),
          () => this.loadData()
        );
      },
    });
  }
}
